<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :is-modal="isCadastroModal"
      :cancelar-cadastro="fechar"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group class="col-12 my-0 pb-0">
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
              @change="inativarUsuario"
            >
              <label style="font-size: 1rem">Usuário ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-tabs
          card
        >
          <b-tab
            no-body
            title="Geral"
          >
            <b-row class="mt-0">
              <b-col cols="6">
                <b-form-group
                  label="Nome completo"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Nome completo"
                  >
                    <b-form-input
                      v-model="form.nomeCompleto"
                      :state="errors.length > 0 ? false :null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="3"
                class="md"
              >
                <div style="display: flex;">
                  <div>
                    <legend style="font-size: 14px;">
                      E-mail</legend>
                  </div>
                  <div style="padding-left: 0.4rem">
                    <i
                      v-b-tooltip.hover
                      title="O e-mail informado nesse campo receberá as notificações."
                      style="font-size: 0.65rem;"
                      class="question-icon"
                    >
                      <font-awesome-icon
                        :icon="faQuestionCircle"
                      />
                    </i>
                  </div>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="E-mail"
                  rules="required|email"
                >
                  <b-form-input
                    ref="email"
                    v-model="form.email"
                    :state="errors.length > 0 ? false : null"
                    @blur.native="setLogin()"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col cols="3">
                <grupo-usuario-select
                  v-model="form.grupo"
                  :filtrar-por-tipo="true"
                  :tipo-externo="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <b-form-group label="Tipo inscrição">
                  <b-select
                    ref="tipoInscricao"
                    v-model="form.tipoInscricao"
                    :options="['CPF', 'CNPJ']"
                    @change="constroiMascaraInscricao()"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group
                  label="Inscrição"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="form.empresas.some(som => som.socio) ? 'required' : ''"
                    name="Inscrição"
                  >
                    <b-form-input
                      ref="Inscricao"
                      v-model="form.inscricao"
                      v-mask="constroiMascaraInscricao()"
                      class="form-control"
                      @blur.native="validaInscricao"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small v-if="erroValidacao.inscricao" class="text-danger">{{ erroValidacao.inscricao }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="2"
              >
                <b-form-group label="RG">
                  <b-input v-model="form.rg" />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Órgão Emissor">
                  <orgao-emissor-select v-model="form.orgaoEmissor" />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <legend class="col-form-label pt-0">
                  UF
                </legend>
                <estado-select
                  v-model="form.ufUsuario"
                />
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="3">
                <b-form-group label="Estado civil">
                  <validation-provider
                    #default="{ errors }"
                    :rules="form.empresas.some(som => som.socio) ? 'required' : ''"
                    name="Estado civil"
                  >
                    <b-form-select
                      v-model="form.estadoCivil"
                      :options="opcoesEstadoCivil"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="3"
              >
                <b-form-group label="Profissão">
                  <validation-provider
                    #default="{ errors }"
                    :rules="form.empresas.some(som => som.socio) ? 'required' : ''"
                    name="Profissão"
                  >
                    <b-form-input v-model="form.profissao" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Nacionalidade">
                  <validation-provider
                    #default="{ errors }"
                    :rules="form.empresas.some(som => som.socio) ? 'required' : ''"
                    name="Nacionalidade"
                  >
                    <b-input
                      v-model="form.nacionalidade"
                      type="text"
                      @keypress="isLetter($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Data de nascimento">
                  <validation-provider
                    #default="{ errors }"
                    :rules="form.empresas.some(som => som.socio) ? 'required' : ''"
                    name="Data de nascimento"
                  >
                    <data-input
                      v-model="form.dataNascimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Celular">
                  <b-input-group>
                    <masked-input
                      ref="celular"
                      v-model="form.celular"
                      :mask="constroiMascaraContato"
                      class="form-control"
                      placeholder=""
                    />
                    <b-input-group-append>
                      <b-button
                        v-b-tooltip.hover
                        :pressed.sync="form.celularWhatsApp"
                        title="Celular possui WhatsApp"
                        :size="isCadastroModal ? 'sm' : ''"
                        :style="isCadastroModal ? 'padding: 0.8em 1.2rem' : ''"
                        :variant="form.celularWhatsApp ? 'success' : 'outline-success'"
                        class="whatsapp-btn"
                      >
                        <feather-icon icon="MessageCircleIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="dados-acesso">
              <b-col cols="12">
                <dados-acesso
                  ref="dadoAcesso"
                  v-model="form.acessoUsuario"
                  :erro-validacao="erroValidacao"
                  :is-cadastro-modal="isCadastroModal"
                  :valida-login="validaLogin"
                  :show-senha="false"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <h4>Empresas</h4>
                <fieldset class="font-weight-bold text-muted small">
                  Selecione as empresas vinculadas a este usuário com suas informações
                </fieldset>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <hr
                  class="mx-0 mt-0 mb-2"
                  style="border-top: 1px solid #a3a4a66b !important;"
                >
              </b-col>
            </b-row>
            <empresa-usuario-externo-row
              v-for="(item,$index) in form.empresas"
              :key="$index"
              v-model="form.empresas[$index]"
              :filtro-adicional="removerEmpresaDuplicada"
              :campos-desabilitados="!item.ativa"
              :item-acesso="$index"
              :usuario-id="form.id"
              @novo="adicionaEmpresaPorCima"
              @remove="removerEmpresa"
            />
          </b-tab>
          <b-tab
            no-body
            title="Endereço e Anexo"
          >
            <aba-endereco-usuario
              ref="abaEndereco"
              v-model="form.endereco"
              :empresa-socio="form.empresas.some(som => som.socio)"
              :nome-arquivo="form.nomeArquivoUsuario"
              :id-usuario="form.id"
              @selecionado-arquivo="arquivoSelecionado"
              @removido="form.nomeArquivoUsuario = null"
              @limparEndereco="limparEndereco"
            />
          </b-tab>
        </b-tabs>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.whatsapp-btn {
  float: right;
}

.dados-acesso {
  margin-top: -3rem;
}
</style>

<script>

import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comuns/usuario-externo/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'UsuarioExterno',
  components: {
    CadastroBase,
    ValidationProvider,
    FontAwesomeIcon,
    GrupoUsuarioSelect: () => import('@/shared/components/grupo-usuario-select/GrupoUsuarioSelect.vue'),
    DadosAcesso: () => import('@/shared/components/dados-acesso/DadosAcesso.vue'),
    EmpresaUsuarioExternoRow: () => import('./empresa-usuario-externo-row/EmpresaUsuarioExternoRow.vue'),
    AbaEnderecoUsuario: () => import('./aba-endereco-usuario-externo/AbaEnderecoUsuarioExterno.vue'),
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    OrgaoEmissorSelect: () => import('@/shared/components/orgao-emissor-select/OrgaoEmissorSelect.vue'),
  },
  mixins: [togglePasswordVisibility],
  props: {
    isCadastroModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      faQuestionCircle,
      form: {
        id: 0,
        nomeCompleto: '',
        inscricao: '',
        tipoInscricao: 'CPF',
        celular: '',
        celularWhatsApp: false,
        email: '',
        grupo: null,
        acessoUsuario: {
          login: '',
          senha: '',
          alterarSenha: false,
        },
        ativo: true,
        ufUsuario: null,
        estadoCivil: '',
        rg: null,
        nacionalidade: null,
        profissao: null,
        dataNascimento: null,
        orgaoEmissor: null,
        endereco: {
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          uf: null,
          residenteExterior: false,
        },
      },
      immutableForm: {},
      erroValidacao: { inscricao: '', login: '' },
      opcoesEstadoCivil: ['', 'Solteiro (a)', 'Casado (a)', 'Separado (a)', 'Divorciado (a)', 'Viúvo (a)'],
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    this.$set(this.form, 'empresas', [])
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    } else {
      this.form.acessoUsuario.alterarSenha = false
      this.adicionarEmpresa()
    }
  },
  methods: {
    // eslint-disable-next-line consistent-return
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z]+$/.test(char)) return true
      e.preventDefault()
    },
    removeEmpresa(value) {
      let index = 0
      if (!value.code) {
        index = this.form.empresas.findIndex(fin => fin.empresa.id === value.empresa.id)
      } else {
        index = this.form.empresas.findIndex(fin => fin.code === value.code)
      }
      this.form.empresas.splice(index, 1)

      if (this.form.empresas.length === 0) {
        this.adicionarEmpresa()
      }
    },
    carregar(id) {
      api.getUsuarioExterno(id)
        .then(payload => {
          this.form = payload.data
          if (this.form.empresas.length === 0) {
            this.adicionarEmpresa()
          }
          this.aplicaMascaras()
        })
    },
    salvar() {
      if (this.form.endereco.cep === '' && this.form.empresas.some(som => som.empresa && som.empresa.id > 0 && som.socio)) {
        this.$erro('O campo CEP é obrigatório')
      } else if (this.state !== 'none' && this.form.acessoUsuario.login !== '') {
        api.existeLogin(this.form.id, this.form.acessoUsuario.login)
          .then(payload => {
            if (payload.data) {
              this.erroValidacao.login = 'Login já existente'
            } else {
              this.erroValidacao.login = ''
            }
            this.salvarUsuario()
          })
      }
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'usuariosexternos' })
      } else {
        this.$router.go(-1)
      }
    },
    arquivoSelecionado(name) {
      this.$set(this.form, 'nomeArquivoUsuario', name)
    },
    getFormDataBody(body) {
      const formData = new window.FormData()

      if (this.$refs.abaEndereco && this.$refs.abaEndereco.arquivo) {
        const { file, filename, name } = this.$refs.abaEndereco.arquivo
        formData.append('file', file, filename || name)
      }

      formData.append('body', JSON.stringify(body))

      return formData
    },
    adicionarEmpresa() {
      this.$set(this.form.empresas, this.form.empresas.length,
        {
          code: Date.now().toString(36) + Math.random().toString(36).substring(2),
          ativa: true,
          telefoneWhatsApp: false,
          socio: false,
          porcentagemSocietaria: '0.00%',
        })
    },
    removerEmpresa(value) {
      if (value.empresa && this.form.id !== 0) {
        api.existeCobrancaEmpresa(this.form.id, value.empresa.id)
          .then(payload => {
            if (!payload.data) {
              this.removeEmpresa(value)
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Não é possível realizar a exclusão desta empresa',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
            }
          })
      } else {
        this.removeEmpresa(value)
      }
    },
    constroiMascaraInscricao() {
      if (this.form.tipoInscricao === 'CPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    constroiMascaraContato(contato) {
      const contatoSemMascara = contato ? contato.replace(/\D/g, '') : ''

      if (contatoSemMascara.length === 11) {
        return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      }
      return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    },
    setLogin() {
      if (this.form.acessoUsuario.login === '') {
        this.form.acessoUsuario.login = this.form.email
      }
    },
    aplicaMascaras() {
      if (this.form.tipoInscricao === 'CPF') {
        this.form.inscricao = (this.form.inscricao) ? (this.form.inscricao).replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : ''
      } else {
        this.form.inscricao = (this.form.inscricao) ? (this.form.inscricao).replace(/[^0-9]/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : ''
      }
      this.form.celular = (this.form.celular) ? (this.form.celular).replace(/[^0-9]/g, '').replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : ''
    },
    removerEmpresaDuplicada(empresas) {
      const empresasExistentes = this.form.empresas.filter(fil => fil.empresa)

      if (empresasExistentes && empresasExistentes.length > 0) {
        const empresasFiltradas = []
        empresas.forEach(each => {
          if (!empresasExistentes.find(index => index.empresa.id === each.id)) {
            empresasFiltradas.push(each)
          }
        })
        return empresasFiltradas
      }
      return null
    },
    validaInscricao() {
      if (this.form.inscricao !== '') {
        const inscricao = this.form.inscricao ? this.form.inscricao.replace(/\D/g, '') : ''
        api.existeInscricao(this.form.id, inscricao)
          .then(payload => {
            if (payload.data) {
              this.erroValidacao.inscricao = 'CPF/CNPJ já existente'
            } else {
              this.erroValidacao.inscricao = ''
            }
          })
      }
    },
    salvarUsuario() {
      if (!this.erroValidacao.inscricao && !this.erroValidacao.login) {
        return new Promise((resolve, reject) => {
          this.form.inscricao = this.form.inscricao ? this.form.inscricao.replace(/\D/g, '') : ''
          this.form.celular = this.form.celular ? this.form.celular.replace(/\D/g, '') : ''

          this.$set(this.form, 'empresas', this.removeEmpresasVazias())

          const formData = this.getFormDataBody(this.form)
          if (this.state === 'novo') {
            api.createUsuarioExterno(formData)
              .then(payload => {
                this.fechar()
                this.$confirmar('Cadastro realizado com sucesso!', 'Deseja enviar o convite de acesso por email agora?', 'question', 'danger')
                  .then(result => {
                    if (result.value) {
                      api.conviteAcesso(payload.data)
                        .then(() => {
                          resolve('Convite enviado para o email do usuário externo')
                          this.$sucesso('Convite enviado para o email do usuário externo')
                        })
                        .catch(err => {
                          this.$erro(err.response.data.message || err.message)
                          reject(err)
                        })
                    } else {
                      resolve('Usuário externo cadastrado com sucesso')
                      this.$sucesso('Usuário externo cadastrado com sucesso')
                    }
                  })
              })
              .catch(err => {
                reject(err)
              })
          } else {
            api.updateUsuarioExterno(this.form.id, formData)
              .then(() => {
                this.fechar()
                resolve('Usuário externo alterado com sucesso')
                this.$sucesso('Usuário externo alterado com sucesso')
              })
              .catch(err => {
                this.$erro(err.response.data.message || err.message)
                reject(err)
              })
          }
        })
      }
      if (this.erroValidacao.cpf) {
        this.$refs.cpf.$el.focus()
        this.erroValidacao.cpf = ''
      }

      if (this.erroValidacao.login) {
        this.$refs.dadoAcesso.$el.$refs.login.el.focus()
        this.erroValidacao.login = ''
      }

      return null
    },
    validaLogin() {
      if (this.state !== 'none' && this.form.acessoUsuario.login !== '') {
        api.existeLogin(this.form.id, this.form.acessoUsuario.login)
          .then(payload => {
            if (payload.data) {
              this.erroValidacao.login = 'Login já existente'
            } else {
              this.erroValidacao.login = ''
            }
          })
      }
    },
    removeEmpresasVazias() {
      const novasEmpresas = []
      for (let index = 0; index < this.form.empresas.length; index += 1) {
        const element = this.form.empresas[index]
        if (element.empresa) {
          novasEmpresas.push(element)
        }
      }
      return novasEmpresas
    },
    adicionaEmpresaPorCima() {
      this.adicionarEmpresa()
      const ultimoAdicionado = this.form.empresas[this.form.empresas.length - 1]
      this.form.empresas.splice(this.form.empresas.length - 1, 1)
      this.form.empresas.splice(0, 0, ultimoAdicionado)
    },
    inativarUsuario(checked) {
      if (!checked) {
        this.$swal({
          title: 'Deseja realmente inativar esse usuário?',
          text: 'Não serão geradas novas cobranças de documentos para as empresas vinculadas a esse usuário '
          + 'e as cobranças em tramitação no portal vinculadas a este usuário não gerarão novas notificações por e-mail.'
          + 'Somente voltará a notificar quando efetuado a troca do contato inativo por um ativo no cadastro de empresas.',
          confirmButtonText: 'Confirma',
          cancelButtonText: 'Cancela',
          showCancelButton: true,
          focusConfirm: false,
          icon: 'warning',
          customClass: {
            confirmButton: 'mr-1 w-25 btn-primary',
            cancelButton: 'w-25 btn-danger',
          },
        }).then(result => {
          if (!result.value) {
            this.form.ativo = !checked
          }
        })
      }
    },
    limparEndereco(value) {
      this.form.endereco = value
    },
  },
}
</script>
